import { cloneDeepWith } from 'lodash-es';

export function trimAllIn(data: Record<string, unknown>) {
  return cloneDeepWith(data, (value) => (typeof value === 'string' ? value.trim() : undefined));
}
